"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CONTROLS : CONTROL : STYLES --------------- ++++++++++ */


var _default = {
  control: {
    height: (0, _index.pxToEm)(46),
    minWidth: (0, _index.pxToEm)(140),
    // 165
    border: "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.neutral.light.swatch, " solid"),
    fontSize: (0, _index.pxToEm)(18),
    fontWeight: _index.theme.typography.weight.medium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'filter .15s ease-in 0s',
    '&:hover': {
      filter: 'brightness(83%)'
    },
    '&:first-child': {
      borderRadius: (0, _index.replacePXinStringWithEM)("5px 0px 0px 5px")
    },
    '&:last-child': {
      borderRadius: (0, _index.replacePXinStringWithEM)("0px 5px 5px 0px")
    },
    '&.selected-true': {
      color: _index.theme.color.primary.medium.swatch,
      boxShadow: _index.theme.boxShadow.inset,
      border: function border(props) {
        return props.variant === 'secondary' ? "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.primary.medium.swatch, " solid") : "".concat((0, _index.pxToEm)(1), " ").concat(_index.theme.color.neutral.light.swatch, " solid");
      },
      backgroundColor: function backgroundColor(props) {
        return props.variant === 'secondary' ? 'rgba(129, 201, 255, 0.09)' : _index.theme.color.light.light.swatch;
      },
      '&:hover': {
        filter: 'brightness(98%)'
      }
    },
    '&.selected-false': {
      color: _index.theme.color.primary.dark.swatch
    },
    '&.variant-secondary': {
      borderRadius: (0, _index.pxToEm)(12),
      marginRight: (0, _index.pxToEm)(5),
      fontSize: (0, _index.pxToEm)(16),
      height: (0, _index.pxToEm)(48),
      WebkitTransform: 'translate3d(0,0,0)',
      '&:last-child': {
        marginRight: '0px'
      }
    },
    '& .checkmark': {
      display: function display(props) {
        return props.variant === 'secondary' && props.addCheckWhenSelected && props.selected ? 'block' : 'none';
      },
      marginLeft: (0, _index.pxToEm)(10),
      fontSize: (0, _index.pxToEm)(12),
      width: (0, _index.pxToEm)(16),
      height: (0, _index.pxToEm)(16)
    }
  }
};
exports.default = _default;